import { Component, Input, OnChanges } from '@angular/core';

import { UserContextService } from 'rev-shared/security/UserContext.Service';
import { IPresenter } from 'rev-shared/webrtc/Contract';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import { dragOptions } from './ProducerVideoControls.Component';
import { IProducerOptions } from '../../Contract';

import styles from './PresenterVideo.module.less';
@Component({
	selector: 'presenter-video-list',
	templateUrl: './PresenterVideoList.Component.html',
	host: { '[class]': 'styles.presenterVideoListRoot' },
	standalone: false
})
export class PresenterVideoListComponent implements OnChanges {
	@Input() public webcast: WebcastModel;
	@Input() public canEditLayout: boolean;
	@Input() public backstageVolume: number;
	@Input() public onstageVolume: number;
	@Input() public onstageUsers: string[];
	@Input() public presenters: IPresenter[];
	@Input() public producerIds: string[];
	@Input() public producerOptions: IProducerOptions;

	public presentersList: IPresenter[];

	public readonly dragOptions = dragOptions;
	public readonly styles = styles;

	constructor(
		private readonly UserContext: UserContextService
	)
	{}

	public ngOnChanges(): void {
		const userId = this.UserContext.getUser().id;
		this.presentersList = this.presenters.filter(p => p.id !== userId);
	}

	public isProducer(id: string): boolean {
		return this.producerIds.includes(id);
	}

	public trackByPresenterId(index: number, presenter: IPresenter): string {
		return presenter.id;
	}
}
